import React, { Component } from 'react';
import moment from 'moment';

export class DetalheHistoricoRepasse extends Component {

    render() {
        const { visualizarDetalheHistorico } = this.props;
        const { item } = this.props;

        return (
            visualizarDetalheHistorico && <div className="card-body cinza-zebrado table-responsive-sm">
                <table className="table table-sm table-bordered">
                     <tbody >
                        <tr style={{ backgroundColor: '#ffffff66' }}>
                            <td colSpan='5' className='text-center'><strong>Detalhe Histórico</strong> </td>
                        </tr>
                        <tr>
                            <td><strong>Total taxa embarque:</strong> R$ {item.totalTaxaEmbarque ? item.totalTaxaEmbarque : '0,00'}</td>
                            <td><strong>Total seguro:</strong> R$ {item.totalTarifaSeguro ? item.totalTarifaSeguro : '0,00'}</td>
                            <td><strong>Total pedágio:</strong> R$ {item.totalPedagio ? item.totalPedagio : '0,00'}</td>  
                            <td><strong>Total Comissão Agente:</strong> R$ {item.totalComissaoAgente ? item.totalComissaoAgente : '0,00'}</td>  
                        </tr>
                        <tr>
                            <td colSpan={4}><strong>Usuário Responsável:</strong> {item.nomeResponsavel}</td>
                        </tr>
                        <tr>                            
                            <td><strong>Data de repasse:</strong>{moment(item.data).format('DD/MM/YYYY')}</td>
                            <td><strong>Data inicio apuracão:</strong>{moment(item.dataInicio).format('DD/MM/YYYY')}</td>
                            <td><strong>Data fim apuracão:</strong>{moment(item.dataFim).format('DD/MM/YYYY')}</td>                            
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}